import { render, staticRenderFns } from "./LanguageRadio.vue?vue&type=template&id=634d6708&"
import script from "./LanguageRadio.vue?vue&type=script&lang=js&"
export * from "./LanguageRadio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports